export type BnuyFact = {
  fact: string
  sourceLabel: string
  sourceUrl: string
}

export const BNUY_FACTS: BnuyFact[] = [
  {
    fact: 'Rabbits can see almost 360 degrees around them thanks to the position of their eyes, but they have a small blind spot right in front of their nose.',
    sourceLabel: 'rabbit.org',
    sourceUrl: 'https://rabbit.org/health/the-rabbit-eye-a-complete-guide/',
  },
  {
    fact: "Rabbits' teeth never stop growing, so they need to chew constantly to keep them worn down to a healthy length.",
    sourceLabel: 'RSPCA',
    sourceUrl: 'https://www.rspca.org.uk/adviceandwelfare/pets/rabbits',
  },
  {
    fact: 'Rabbits perform an athletic leap, known as a "binky", when they\'re happy — performing twists and kicks in mid air!',
    sourceLabel: 'National Geographic',
    sourceUrl:
      'https://www.natgeokids.com/uk/discover/animals/general-animals/10-hopping-fun-rabbit-facts/',
  },
  {
    fact: 'The family Leporidae (rabbits and hares) has been relatively unchanged since the Eocene Epoch about 40 million years ago, when its fossil record first became well documented.',
    sourceLabel: 'Britannica',
    sourceUrl: 'https://www.britannica.com/animal/rabbit',
  },
  {
    fact: 'Rabbits are crepuscular, meaning they are most active around dawn and dusk rather than during the day or at night.',
    sourceLabel: 'PDSA',
    sourceUrl:
      'https://www.pdsa.org.uk/what-we-do/blog/vet-qas-are-rabbits-nocturnal',
  },
  {
    fact: "A healthy rabbit's heart beats between 130 and 325 times per minute, much faster than a human's resting heart rate.",
    sourceLabel: 'House Rabbit Resource Network',
    sourceUrl:
      'https://rabbitresource.org/rabbit-care-information-and-resources/medical/rabbit-vital-signs/',
  },
  {
    fact: "Newborn kits have almost no scent of their own, so mother rabbits stay away from the nest and nurse just once or twice a day - usually around dawn and dusk - since her stronger adult scent could draw a predator's attention.",
    sourceLabel: 'House Rabbit Society',
    sourceUrl: 'https://rabbit.org/care/babies/',
  },
  {
    fact: 'Wild rabbits live in extensive underground burrow systems called warrens with dozens of interconnected entrances.',
    sourceLabel: 'The Wildlife Trusts',
    sourceUrl:
      'https://www.wildlifetrusts.org/wildlife-explorer/mammals/rabbit',
  },
  {
    fact: "A rabbit's ears can rotate up to 180 degrees to pinpoint exactly where a sound is coming from, and their large size also helps rabbits stay cool in warm weather.",
    sourceLabel: 'PDSA',
    sourceUrl:
      'https://www.pdsa.org.uk/what-we-do/blog/10-things-you-might-not-know-about-rabbits',
  },
  {
    fact: "Rabbits thump their hind legs firmly on the ground to warn other rabbits nearby of potential danger - or when they're grumpy.",
    sourceLabel: 'RSPCA',
    sourceUrl: 'https://www.rspca.org.uk/adviceandwelfare/pets/rabbits',
  },
]

export function getRandomBnuyFact(): BnuyFact {
  return BNUY_FACTS[Math.floor(Math.random() * BNUY_FACTS.length)]
}
